import React, { createContext, useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useVisualViewport } from '@wix/da-ds/pkg/hooks/useVisualViewport';
import { MeasuredCookieType } from '../redux/types';
import { useMeasuredCookieState, DEFAULT_SIZE } from '../useMeasuredCookieState';
import { getEnv } from '@wix/da-react-app/pkg/client/Environment/redux/selectors';
import { useSelector } from 'react-redux';
import isServerSideRendering from '../../utils/isSSR';
export const ScreenSizeContext = /*#__PURE__*/ createContext(DEFAULT_SIZE.desktop);
ScreenSizeContext.displayName = 'ScreenSizeContext';
export const ScreenSizeContextProvider = ({ children })=>{
    const isMobile = useContext(MobileContext);
    const appEnv = useSelector(getEnv);
    const defaultNoHints = isMobile ? DEFAULT_SIZE.mobile : DEFAULT_SIZE.desktop;
    const measured = useMeasuredCookieState(MeasuredCookieType.SCREEN_WIDTH, 'both', DEFAULT_SIZE);
    let { containerSize = appEnv.clientHints ? {
        width: appEnv.clientHints.width,
        height: appEnv.clientHints.height
    } : defaultNoHints } = measured;
    // Prefer client hint over cookie values on the server, this is not inside measured
    // itself because we have measurements that are not full viewport, hence we only
    // do this for the screensize measure
    if (isServerSideRendering() && appEnv.clientHints) {
        // Android has bug that initial pageloads can report its default 980 width
        // therefore if we see 980 we fallback to cookies
        if (isMobile && appEnv.clientHints.width === 980) {
            var _measured_containerSize;
            containerSize = (_measured_containerSize = measured.containerSize) !== null && _measured_containerSize !== void 0 ? _measured_containerSize : defaultNoHints;
        } else {
            containerSize = {
                width: appEnv.clientHints.width,
                height: appEnv.clientHints.height
            };
        }
    }
    // VisualViewport
    useVisualViewport(measured.updateContainerSize);
    return /*#__PURE__*/ React.createElement(ScreenSizeContext.Provider, {
        value: containerSize
    }, children);
};
ScreenSizeContextProvider.displayName = 'ScreenSizeContextProvider';
